module.exports = __webpack_public_path__ + "static/WEDDING E&M-507-bc63e322d1931cb66441ce6325c110d6.jpg";